import React from "react"
import { Box } from "@theme-ui/components"

const BrochureEmbed = ({ code }) => {
  return <Box dangerouslySetInnerHTML={{ __html: code }} />
}

export default BrochureEmbed
